<template>
    <div>
        <router-link
            :to="makeEntityRoute('event', event)"
            class="exclusive-featured-event-link">
            <div
                class="exclusive-featured-event-image exclusive-featured-event-image--mobile"
                v-if="isWindowSmall || isWindowMedium"
                :style="{ backgroundImage: `url(${event.imageUrlSquare})` }"></div>
            <div
                class="exclusive-featured-event-image exclusive-featured-event-image--desktop"
                v-else
                :style="{ backgroundImage: `url(${event.imageUrlSquare})` }"></div>

            <div class="exclusive-featured-event-details">
                <div class="exclusive-featured-event-details__name">
                    <v-clamp :max-lines="2" autoresize>{{ event.name }}</v-clamp>
                </div>
                <div class="exclusive-featured-event-details__time">
                    <span v-if="event.is_date_tbh">{{ $t('Date TBD') }}</span>
                    <span v-else-if="event.is_time_tbd">{{ event.local_date | date('ddd, MMM D') }}, {{ $t('Time TBD') }}</span>
                    <span v-else-if="event.local_date_label">{{ event.local_date_label }} at  <span class="exclusive-featured-event-details__time-location">{{ event.local_date | date('h:mma') }}</span></span>
                    <span v-else>{{ event.local_date | date('ddd, MMM D') }} <span class="exclusive-featured-event-details__time-location"> at {{ event.local_date | date('h:mma') }}</span></span>
                    <br>
                    <span class="exclusive-featured-event-details__location">
                        <span class="exclusive-featured-event-details__location-venue">{{ event.venueCity }}, {{ event.venueRegionCode }}<span class="separator">·</span></span>
                        <Tag
                            v-if="event.is_sold_out"
                            context="error"
                            text="Sold Out" />
                        <span v-else-if="isLoyaltyPricing && event.pointsPriceMin">from {{ formatPoints(event.pointsPriceMin, event.pointsCurrency) }}</span>
                        <span v-else>from {{ event.moneyPriceMin | numeral('$0,0')}}</span>
                    </span>
                </div>
            </div>
        </router-link>
    </div>
</template>

<script>
import { makeEntityRoute } from '../services/EntityService'
import loyaltyFormattable from '../mixins/LoyaltyFormattable'
import resizable from '../mixins/Resizable'
import Tag from 'core/components/TagComponent.vue'
import trackable from '../mixins/Trackable'
import VClamp from 'vue-clamp'

export default {
    name: 'FeaturedEventTile',
    components: {
        Tag,
        VClamp
    },
    props: {
        event: {
            type: Object,
            required: true,
            default: null
        },
        index: {
            type: Number,
            required: true
        }
    },
    computed: {
        isLoyaltyPricing () {
            return this.$store.state.isRedeemingLoyaltyPoints
        }
    },
    methods: {
        makeEntityRoute
    },
    mixins: [
        loyaltyFormattable,
        resizable,
        trackable
    ]
}
</script>

<style lang="postcss" scoped>
@import 'theme';

.exclusive-featured-event-link {
    text-decoration: none;
    &:hover {
        text-decoration: none;
    }

    & .exclusive-featured-event-image {
        background-size: cover;
        border-top-right-radius: 4px;
        border-top-left-radius: 4px;
        height: 143px;
        width: auto;
        z-index: 1;
        @media (--mq-large-min) {
            width: 279px;
        }

        &.exclusive-featured-event-image--desktop {
            display: none;
            @media (--mq-large-min) {
                display: block;
            }
        }

        &.exclusive-featured-event-image--mobile {
            display: block;
            @media (--mq-large-min) {
                display: none;
            }
        }
    }

    & .exclusive-featured-event-details {
        background: transparent;
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
        margin: 0;
        padding: 0 16px 16px;
        position: relative;
        z-index: 20;
        overflow: hidden;
        & .exclusive-featured-event-details__name {
            color: #444649;
            font-size: var(--fs-large);
            font-weight: var(--fw-bold);
            height: 58px;
            padding: 8px 0;
            overflow: hidden;
            text-overflow: ellipsis;;
        }
        & .exclusive-featured-event-details__time {
            color: #444649;
            font-weight: var(--fw-normal);
            font-size: var(--fs-normal);
            & .exclusive-featured-event-details__time-location {
                font-weight: 100;
                color: #808689
            }
        }
        & .exclusive-featured-event-details__location {
            color: #128020;
            & .exclusive-featured-event-details__location-venue {
                color: #808689;
                font-weight: 100;
            }
            & .separator {
                color: #808689;
                margin-left: 4px;
            }
        }

        & >>>.tag--error {
            padding: 0 8px;
        }
    }
}

</style>
